export const CtiStatusFilterType = {
  all: 'all',
  ringing: 'ringing',
  calling: 'calling',
  ended: 'ended',
  missed: 'missed',
  recall: 'recall',
  handled: 'handled',
};
